import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import { TurnoActualTab } from "./tabs/TurnoActualTab";
import { TurnosFinalizadosTab } from "./tabs/TurnosFinalizadosTab";
import "./styles/TurnosProduccion.css";

class TurnosProduccion extends Component {
    navigateToPaletizaciones = () => {
        this.props.history.push(`/produccion-v2/paletizaciones`);
    };

    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tab1FromUrl = params.get("tab1");
        let tab2FromUrl = params.get("tab2");

        // significa que fue carga nueva
        if (!tab1FromUrl) {
            tab1FromUrl = "TURNO_ACTUAL";
            tab2FromUrl = "PENDIENTES";

            params.set("tab1", tab1FromUrl);
            params.set("tab2", tab2FromUrl);

            this.props.history.replace({
                search: params.toString(),
            });
        }

        if (!tab2FromUrl) {
            tab2FromUrl = "PENDIENTES";

            params.set("tab2", tab2FromUrl);

            this.props.history.replace({
                search: params.toString(),
            });
        }

        this.state = {
            tab1: tab1FromUrl,
            tab2: tab2FromUrl,
        };
    }

    handleChangeTab1 = (tab1) => {
        this.setState({ tab1 });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab1", tab1);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    handleChangeTab2 = (tab2) => {
        this.setState({ tab2 });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab2", tab2);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    navigateToTancadas = (idOrden, paletizacionCerrada) => {
        if (paletizacionCerrada) {
            this.props.history.push(
                `/produccion-v2/detalle-tancadas/${idOrden}`,
            );
        } else {
            this.props.history.replace(`/produccion-v2/tancadas/${idOrden}`);
        }
    };

    navigateToCierreTurno = () => {
        this.props.history.push(`/produccion-v2/cierre-turno`);
    };

    render() {
        const { user } = this.props;

        const nombreUsuario = user ? user.nombre : "No definido";

        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "90vw", margin: "auto" }}
            >
                <Card
                    icon="produccion_activo"
                    titulo="Producción Sólidos"
                    subtitulo="Comenzar turno"
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab1}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab1}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent />}
                    >
                        <TabPane tab="Turno Actual" key="TURNO_ACTUAL">
                            <TurnoActualTab
                                tabActiva={this.state.tab1}
                                nombreUsuario={nombreUsuario}
                                navigateToTancadas={this.navigateToTancadas}
                                tab2={this.state.tab2}
                                handleChangeTab2={this.handleChangeTab2}
                                navigateToPaletizaciones={
                                    this.navigateToPaletizaciones
                                }
                                navigateToCierreTurno={
                                    this.navigateToCierreTurno
                                }
                            />
                        </TabPane>
                        <TabPane
                            tab="Turnos Finalizados"
                            key="TURNOS_FINALIZADOS"
                        >
                            <TurnosFinalizadosTab
                                storageKey="prodv2-turnos-finalizados"
                                mostrarTabTurnoActual={() =>
                                    this.handleChangeTab1("TURNO_ACTUAL")
                                }
                            />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(TurnosProduccion);
